import { Component, ViewChild } from '@angular/core';
import { FileContext } from 'src/app/interfaces/file.interface';
import { FormFieldSate } from '../../form-field.state';
import { FileFormFieldComponent } from '../file-form-field/file-form-field.component';

@Component({
  selector: 'app-document-form-field',
  templateUrl: './document-form-field.component.html',
  styleUrls: ['./document-form-field.component.scss'],
})
export class DocumentFormFieldComponent extends FormFieldSate implements FileContext {
  @ViewChild(FileFormFieldComponent, { static: false })
  public fileComponent: FileFormFieldComponent;
  public fileLink = '';

  public updateFile(link: string): void {
    this.fileLink = link;
  }

  public delete(): void {
    this.fileComponent.deleteAssociation();
    this.updateFile('');
  }

  public onError(): void {
    this.formStateService.validateControl(this.control);
    this.control.setErrors(
      this.fieldAttribute.multiple ? { notValidMultipleFiles: true } : { notRequiredFileType: true },
    );

    setTimeout(() => this.control.setErrors(null), 5000);
  }
}
